module.exports = __webpack_public_path__ + "static/media/default-bg.27da0051.png";